import React from "react";

const Section = ({
    reverse = false,
    heading = "Our Purpose",
    className,
    imageUrl = "/images/section/sectionImg1.png",
    description = "Our fiberglass company's fundamental purpose is to excel in the manufacturing and supply of top-tier fiberglass products. We aim to deliver high-quality solutions that cater to the diverse needs of industries and clients, ensuring our products are not only reliable and durable but also environmentally responsible. Our commitment to sustainability drives us to employ eco-friendly materials and processes, minimizing our environmental impact.",
}) => {
    return (
        <div className={` ${className} ${reverse && "flex-row-reverse max-sm:flex-col"} max-sm:flex-col flex items-center justify-between px-[4vw] py-[64px] max-lg:flex-col gap-[90px] max-lg:gap-[32px] max-w-[1980px]`}>
            <div className="flex flex-col gap-[16px] max-lg:items-center w-full">
                <h2 className="text-[#101828] text-[30px] font-[600] max-lg:text-center">
                    {heading}
                </h2>
                <p className="text-[18px] text-[#1D1D1B] max-w-[100%] max-lg:text-[16px] max-lg:text-center">
                    {description}
                </p>
            </div>
            <div className={`w-full flex items-end justify-end max-lg:items-center max-lg:justify-center ${reverse && "!items-start !justify-start max-sm:!items-center max-sm:!justify-center"}`}>
                <div className="bg-[#F2F4F7] rounded-[10px] p-[40px] max-sm:w-full max-sm:p-[16px]">
                    <img className="max-w-[650px] max-xl:max-w-[480px] max-sm:max-w-full rounded-[10px] border-[3px] border-[#101828]" src={imageUrl} alt="" />
                </div>
            </div>
        </div>
    );
};
export default Section;